import {
  getObject,
  getString,
  getOptionalString,
} from "@surya-digital/leo-ts-types";
import { Code, CodeDTO } from "./code";

export interface SingleChoiceAnswerV1DTO {
  code: CodeDTO;
  answer?: string | null;
}

export class SingleChoiceAnswerV1 {
  readonly isSingleChoiceAnswerV1SingleChoiceAnswerV1: boolean = true;

  readonly code: Code;
  readonly answer: string | null;


  constructor(
  code: Code, 
  answer: string | null = null
  ) {
    this.code = code;
    this.answer = answer;
  }

  static fromDTO(dto: SingleChoiceAnswerV1DTO): SingleChoiceAnswerV1 {
    const code = Code.fromDTO(getObject(dto, "code", InvalidSingleChoiceAnswerV1CodeError));
    const answer = getOptionalString(dto, "answer", InvalidSingleChoiceAnswerV1AnswerError);
    return new SingleChoiceAnswerV1(
      code,
      answer
    );
  }

  toDTO(): SingleChoiceAnswerV1DTO {
    const dto: SingleChoiceAnswerV1DTO = {
        code: this.code.toDTO(),
    };
    if (this.answer !== undefined && this.answer !== null){
      dto.answer = this.answer;
    }
    return dto;
  }
  }

SingleChoiceAnswerV1.prototype.toString = function toString(): string {
  return `SingleChoiceAnswerV1(code='${this.code}',answer='${this.answer}')`;
};

export class InvalidSingleChoiceAnswerV1Error extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSingleChoiceAnswerV1Error";
  }
}
export class InvalidSingleChoiceAnswerV1CodeError extends InvalidSingleChoiceAnswerV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSingleChoiceAnswerV1CodeError";
  }
}

export class InvalidSingleChoiceAnswerV1AnswerError extends InvalidSingleChoiceAnswerV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSingleChoiceAnswerV1AnswerError";
  }
}
